import React from "react";
import { useReactToPrint } from "react-to-print";
import { Box, Button, Container, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LinkValues, ResponseValues } from "../../../values/strings";
import { useCoreRequestProvider } from "../../../providers/RequestProvider";
import { useThemeProvider } from "../../../providers/ThemeProvider";
import { TransactionDetailsReceiptListViewComponent } from "../../listview/TransactionListViewComponent";
import { useLanguageProvider } from "../../../providers/LanguageProvider";
import QRCode from "react-qr-code";

export const TransactionReceiptCoreviewMainPageComponent = ({
  urlParams,
  autoOpenApp = false,
}) => {
  const [TxDetails, setTxDetails] = React.useState();
  const { t, i18n } = useTranslation();
  const lang = useLanguageProvider();
  const theme = useThemeProvider();
  const coreRequest = useCoreRequestProvider();
  const printComponentRef = React.useRef();
  const handlePrint = useReactToPrint({
    content: () => printComponentRef.current,
  });

  React.useEffect(async () => {
    if (!TxDetails) {
      const data = await coreRequest.get(
        LinkValues.core.finance.transaction.details(),
        {
          txkey: urlParams.txaddress,
        }
      );
      setTxDetails((data.data && data.data.data) || null);
      if (autoOpenApp) {
        setTimeout(() => {
          document.location.href = LinkValues.schema.transactions(
            urlParams.txaddress
          );
        }, 2000);
      }
    }
  }, [TxDetails]);

  const buildReceipt = () =>
    !TxDetails ? (
      <></>
    ) : (
      <Container maxWidth="xs" disableGutters={true} ref={printComponentRef}>
        <Box
          style={{
            direction: lang.textDirection(),
            backgroundColor: theme.theme.palette.secondary.main,
            padding: 1,
            margin: "auto",
          }}
        >
          <Box
            style={{
              backgroundColor: theme.theme.palette.theme.main,
              borderRadius: "0 0 7px 7px",
              padding: 3,
            }}
          >
            <Grid container item direction="column">
              <Grid
                container
                item
                direction="row"
                paddingX={3}
                paddingY={1}
                columnSpacing={2}
              >
                <Grid container item xs="auto" alignItems="center">
                  <img
                    src={LinkValues.images.icons.navHeaderLight()}
                    hidden={theme.theme.palette.mode != "light"}
                    style={{ height: 40 }}
                  />
                  <img
                    src={LinkValues.images.icons.navHeaderDark()}
                    hidden={theme.theme.palette.mode != "dark"}
                    style={{ height: 40 }}
                  />
                </Grid>
                <Grid container item xs direction="column">
                  <Typography variant="title">{t("app_name")}</Typography>
                  <Typography variant="caption">
                    {t("app_description")}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                item
                direction="row"
                paddingY={1}
                columnSpacing={2}
              >
                <Grid container item xs="auto" alignItems="center">
                  <Box
                    style={{
                      width: 4,
                      height: "100%",
                      backgroundColor: theme.theme.palette.primary.main,
                    }}
                  ></Box>
                </Grid>
                <Grid container item xs direction="column" paddingX={1}>
                  <Typography variant="title">
                    {(ResponseValues.fullName in TxDetails &&
                      TxDetails[ResponseValues.fullName] &&
                      TxDetails[ResponseValues.fullName]) || <></>}
                  </Typography>
                  <Typography variant="caption">
                    {(ResponseValues.identityVerification in TxDetails &&
                      TxDetails[ResponseValues.identityVerification] &&
                      TxDetails[ResponseValues.identityVerification]) || <></>}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                item
                direction="column"
                paddingX={3}
                paddingTop={2}
              >
                <Typography variant="h6">{t("transactionDetails")}</Typography>
              </Grid>
              <Grid container item direction="column" paddingX={1} paddingY={1}>
                <TransactionDetailsReceiptListViewComponent data={TxDetails} />
              </Grid>
            </Grid>
          </Box>
          <Box
            style={{
              backgroundColor: theme.theme.palette.theme.main,
              borderTopColor: theme.theme.palette.secondary.main,
              borderTopWidth: 1,
              borderTopStyle: "dashed",
              borderRadius: "7px 7px 0 0",
              padding: 10,
            }}
          >
            <Grid container direction="row" paddingX={3} columnSpacing={2}>
              <Grid container item xs direction="column">
                <Typography variant="title">{t("serviceProvider")}</Typography>
                <Typography variant="caption">
                  {t("app_name")} - {t("app_description")}
                </Typography>
              </Grid>
              <Grid container item xs="auto" alignItems="center">
                {(ResponseValues.receiptLink in TxDetails &&
                  TxDetails[ResponseValues.receiptLink] && (
                    <QRCode
                      value={TxDetails[ResponseValues.receiptLink]}
                      size={70}
                    />
                  )) || <></>}
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    );

  return (
    <div>
      <Box
        marginY={5}
        className={theme.styles.classes.componentsTransactionReceipt}
      >
        <Grid container item direction="column">
          <Grid container item direction="column">
            {buildReceipt()}
          </Grid>
          <Grid container item direction="row" padding={1} spacing={1}>
            <Grid container item direction="column" xs={12}>
              <Button
                color={"primary"}
                variant="contained"
                onClick={handlePrint}
                disableElevation
                disableRipple
              >
                <Typography variant="navBar">{t("downloadOrPrint")}</Typography>
              </Button>
            </Grid>
            <Grid container item direction="column" xs={6}>
              <Button
                color={"secondary"}
                variant="contained"
                href={LinkValues.routes.initLocale(
                  LinkValues.routes.base(false),
                  lang.supportedLanguages
                )}
                disableElevation
                disableRipple
              >
                <Typography variant="navBar">
                  {t("returnToMainPage")}
                </Typography>
              </Button>
            </Grid>
            <Grid container item direction="column" xs={6}>
              <Button
                color={"secondary"}
                variant="contained"
                href={LinkValues.schema.transactions(urlParams.txaddress)}
                disableElevation
                disableRipple
              >
                <Typography variant="navBar">{t("returnToApp")}</Typography>
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};
